import {HttpClient} from '@angular/common/http';
import {Inject, Injectable} from '@angular/core';

import {map, mergeMap, Observable} from 'rxjs';
import {ItineraryTemplateViewModel} from "../../models/view-models/itinerary-template";
import {UpdatedDocument} from "../../admin/itinerary-templates/itinerary-templates.component";

@Injectable({
  providedIn: 'root',
})
export class HttpItineraryTemplatesService {
  private baseUrl = `${this.serverUrl}itinerary-templates`;

  constructor(private httpClient: HttpClient, @Inject('API_URL') public serverUrl: string) {
  }

  public getItineraryTemplates(): Observable<ItineraryTemplateViewModel[]> {
    return this.httpClient.get<ItineraryTemplateViewModel[]>(`${this.baseUrl}`);
  }

  public updateItineraryTemplate(id: number, itineraryTemplate: ItineraryTemplateViewModel) {
    const {Document: _, ...rest} = itineraryTemplate;
    let observable = this.httpClient.put<void>(`${this.baseUrl}/${id}`, rest);

    if (itineraryTemplate.Document.Id == 0) {
      const formData = new FormData();
      const newFile = itineraryTemplate.Document as UpdatedDocument
      formData.append('document', newFile._file, newFile.FileName);
      observable = observable.pipe(mergeMap(() => this.httpClient.put<void>(`${this.baseUrl}/${id}/document`, formData)));
    }
    return observable;
  }

  public createItineraryTemplate(itineraryTemplate: any) {
    const {Document: a1, Id: a2, ...rest} = itineraryTemplate;

    let observable =  this.httpClient.post<number>(`${this.baseUrl}`, rest);
    if (itineraryTemplate.Document.Id == 0) {
      const formData = new FormData();
      const newFile = itineraryTemplate.Document as UpdatedDocument
      formData.append('document', newFile._file, newFile.FileName);
      observable = observable.pipe(mergeMap((id) => this.httpClient.put<void>(`${this.baseUrl}/${id}/document`, formData).pipe(map(_ => id))));
    }
    return observable;
  }

  public deleteItineraryTemplate(id: number) {
    return this.httpClient.delete<void>(`${this.baseUrl}/${id}`);
  }

}
